import axios from 'axios'
import { getToken,removeToken } from '@/utils/auth'
import { Loading } from 'element-ui';
import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({ showSpinner: false }); 
import router from '@/router/router'

const service = axios.create({
    baseUrl: '/',
    timeout: 5000,
})
let loadingInstance
service.interceptors.request.use(config=>{
    NProgress.start(); 
    loadingInstance = Loading.service({ fullscreen: true ,text:"加载中，请稍后...",spinner:"el-icon-loading",background:"rgba(0, 0, 0, 0.8)"});
    if(getToken()){
        config.headers['Authorization'] = ' Bearer '+getToken();
    }
    config.headers['Content-Type']='application/json;charset=UTF-8'
    return config
},error=>{
    console.log(error)
    return promise.reject(error)
})

service.interceptors.response.use(response=>{
    NProgress.done(); 
    loadingInstance.close();
    // if(response.status !== 200){
    //         Message({
    //             message: response.message || 'error',
    //             type:'error', 
    //             duration:5000
    //         }) 
    // }
    return response
},error=>{
    NProgress.done();
    // alert('服务器数据响应失败'+error)
    console.log(error);
    if(error.response.status==401){
        removeToken()
        router.replace({
            path:'/login'
        })
        loadingInstance.close();
    }
})

export default service